import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isFeatureEnabled } from "src/utilities";

import { Dispatch, StoreState } from "../../store";
import Container from "../Container";
import BarChartNbaAcceptedTopTen from "./BarChartNbaAcceptedTopTen";
import CustomerContactsOfferAcceptedByContactChannelChart from "./CustomerContactsOfferAcceptedIfAddressedChart";
import CustomersWithNbaChart from "./CustomerContactsWithNbaChart";
import DifferentCategoriesChart from "./DifferentCategoriesChart";
import GaugeChartContactsOfferAcceptedByContactChannel from "./GaugeChartContactsOfferAcceptedIfAddressed";
import GaugeChartContactsWithNbaLastWeek from "./GaugeChartContactsWithNbaLastWeek";
import GaugeChartNbaAddressed from "./GaugeChartOfferAddressed";
import HeatMapMeetingsWithPositiveOutcome from "./HeatMapMeetingsWithPositiveOutcome";
import TopFlopCombinations from "./TopFlopCombinations";

const NbaEvaluation: React.FC = () => {
  const customerContacts = useSelector(
    (state: StoreState) => state.customerContacts
  );
  const [
    customerContactsWithNbaExpanded,
    setCustomerContactsWithNbaExpanded,
  ] = useState(true);
  const [
    differentCategoriesExpanded,
    setDifferentCategoriesExpanded,
  ] = useState(true);
  const [
    differentContactChannelsExpanded,
    setDifferentContactChannelsExpanded,
  ] = useState(true);
  const [nbaTopTenExpanded, setNbaTopTenExpanded] = useState(true);
  const [nbaHeatMapExpanded, setNbaHeatMapExpanded] = useState(true);
  const [topCombinationsExpanded, setTopCombinationsExpanded] = useState(true);

  const dispatch = useDispatch<Dispatch>();
  useEffect(() => {
    dispatch.customerContacts.fetchCustomerContacts("week");
  }, [dispatch]);
  return (
    <Container>
      <Grid container={true} spacing={2}>
        <Grid item={true} xs={12}>
          <Accordion
            expanded={customerContactsWithNbaExpanded}
            onChange={() => setCustomerContactsWithNbaExpanded((prev) => !prev)}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" align="left">
                Kundenkontakte mit hinterlegtem Beratungsfokus
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container justify="space-between" alignItems="center">
                <Grid item lg={3} md={12} xs={12}>
                  <GaugeChartContactsWithNbaLastWeek
                    customerContacts={customerContacts}
                  />
                </Grid>
                <Grid item lg={9} md={12} xs={12}>
                  <div style={{ width: "100%", paddingLeft: "30px" }}>
                    <CustomersWithNbaChart
                      customerContacts={customerContacts}
                    />
                  </div>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item={true} xs={12}>
          <Accordion
            expanded={differentCategoriesExpanded}
            onChange={() => setDifferentCategoriesExpanded((prev) => !prev)}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" align="left">
                Anteile verschiedener Kontakt-Ergebnisse, wenn Beratungsfokus
                vorhanden
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container justify="space-between" alignItems="center">
                <Grid item lg={3} md={12} xs={12}>
                  <GaugeChartNbaAddressed customerContacts={customerContacts} />
                </Grid>
                <Grid item lg={9} md={12} xs={12}>
                  <div style={{ width: "100%", paddingLeft: "30px" }}>
                    <DifferentCategoriesChart
                      customerContacts={customerContacts}
                    />
                  </div>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item={true} xs={12}>
          <Accordion
            expanded={differentContactChannelsExpanded}
            onChange={() =>
              setDifferentContactChannelsExpanded((prev) => !prev)
            }
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" align="left">
                Anteil Angebot angenommen, wenn angesprochen
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container justify="space-between" alignItems="center">
                <Grid item lg={3} md={12} xs={12}>
                  <GaugeChartContactsOfferAcceptedByContactChannel
                    customerContacts={customerContacts}
                  />
                </Grid>
                <Grid item lg={9} md={12} xs={12}>
                  <div style={{ width: "100%", paddingLeft: "30px" }}>
                    <CustomerContactsOfferAcceptedByContactChannelChart
                      customerContacts={customerContacts}
                    />
                  </div>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item={true} xs={12}>
          <Accordion
            expanded={nbaTopTenExpanded}
            onChange={() => setNbaTopTenExpanded((prev) => !prev)}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" align="left">
                Top10-Beratungsfokusse nach Häufigkeit der Ansprache
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <BarChartNbaAcceptedTopTen customerContacts={customerContacts} />
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item={true} xs={12}>
          <Accordion
            expanded={nbaHeatMapExpanded}
            onChange={() => setNbaHeatMapExpanded((prev) => !prev)}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" align="left">
                Heatmap Top10-Beratungsfokusse
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div style={{ width: "100%", padding: 30 }}>
                <HeatMapMeetingsWithPositiveOutcome
                  customerContacts={customerContacts}
                />
              </div>
            </AccordionDetails>
          </Accordion>
        </Grid>
        {isFeatureEnabled(
          process.env.REACT_APP_FEATURE_TOP_FLOP_COMBINATIONS
        ) ? (
          <Grid item={true} xs={12}>
            <Accordion
              expanded={topCombinationsExpanded}
              onChange={() => setTopCombinationsExpanded((prev) => !prev)}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6" align="left">
                  Top / Flop Kombinationen
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TopFlopCombinations customerContacts={customerContacts} />
              </AccordionDetails>
            </Accordion>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
    </Container>
  );
};

export default NbaEvaluation;



// WEBPACK FOOTER //
// ./src/components/NbaEvaluation/index.tsx